module.exports = __webpack_public_path__ + "img/91.7e84277a.svg";